// DS: i8.13
import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const DisabledComment: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      width="0"
      height="0"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g fillRule="evenodd">
        <mask id="i130a" fill="#fff">
          <path
            d="M7.724 7L5.4 3.914l.798-.602L8.977 7H19.07v11.271h-1.6l2.57 3.41-.8.602-3.022-4.012h-7.42L5 21.851V7h2.724zm.59.782H5.781v12.376l2.736-2.606 7.144-.018-7.349-9.752zm1.251 0l7.347 9.75 1.376-.004V7.782H9.565z"
            id="a"
          />
        </mask>
        <g mask="url(#i130a)">
          <path d="M0 0h25v25H0z" />
        </g>
      </g>
    </svg>
  </IconWrap>
);
DisabledComment.displayName = 'DisabledComment';

export default DisabledComment;
